const isComponentType = (element, type) => element.type === type;

export { isComponentType };
//# sourceMappingURL=isComponentType.es.js.map
